import { gql } from '@apollo/client';
import * as Sentry from '@sentry/react';

import { apolloClient } from 'core/apollo-client';

// Internal staff only. The API derives the destination (docs/{accountId}/customer/{policyId}/...)
// from the policy, so the browser only picks what to copy (#36196).
const COPY_INTERNAL_DOC_TO_POLICY_DOCS = gql`
  mutation CopyInternalDocToPolicyDocs($sourcePath: String!, $policyId: ID!, $documentType: String!) {
    copyInternalDocToPolicyDocs(sourcePath: $sourcePath, policyId: $policyId, documentType: $documentType) {
      success
      key
    }
  }
`;

export async function copyInternalDocToPolicyDocs({ internalDocPath, policyId, documentType }) {
  try {
    const { data } = await apolloClient.mutate({
      mutation: COPY_INTERNAL_DOC_TO_POLICY_DOCS,
      variables: { sourcePath: internalDocPath, policyId, documentType }
    });
    return { success: Boolean(data?.copyInternalDocToPolicyDocs?.success) };
  } catch (error) {
    // The modal reports a { success: false } outcome but not its cause, so capture it here.
    Sentry.captureException(error, {
      tags: { flow: 'copyInternalDocToPolicyDocs' },
      extra: { internalDocPath, policyId }
    });
    return { success: false };
  }
}
